// extracted by mini-css-extract-plugin
export default {"headingContainer":"_6QSsceO4SdlQDnLQAjQfxZ","headingText":"_4LzAj5vu5fpDbjWCpipZvG","venueFilter":"_108YeqZaEjkyDVNERdpOeA"};